<template>
    <b-tab
        :active="active"
        :disabled="disabled"
        :title-item-class="titleItemClass"
        :title="title"
        @click="$emit('click', $event)"
        @input="$emit('input', $event)"
    >
        <slot
            name="title"
            slot="title"
        />
        
        <slot />
    </b-tab>
</template>

<script>
import { BTab } from 'bootstrap-vue'

export default {
    components: { BTab },
    props: {
        active: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        title: { type: String, default: '' },
        titleItemClass: { type: [Array, Object, String] },
    },
}
</script>
